module.exports = __webpack_public_path__ + "static/trainer3-c911a267b0d83cb37e807c2a10988d08.png";